<template>
  <div class="mainContainer">
    <div class="nav">
      <div class="navContainer" style="width: 250px">
        <p>对账单编号：</p>
        <el-input v-model="numIpt" size="mini" style="width:150px" placeholder="请输入对账单编号"/>
      </div>
      <div class="navContainer">
        <p>标题：</p>
        <el-input v-model="titleIpt" size="mini" style="width:150px" placeholder="请输入标题"/>
      </div>
      <div class="navContainer" style="width: 210px">
        <p>委托商：</p>
        <el-input v-model="entrustIpt" size="mini" style="width:150px" placeholder="请输入委托商"/>
      </div>
      <div class="navContainer" style="width: 420px">
        <p style="display:inline-block;text-align:center;width: 120px">对账单生成时间：</p>
        <el-date-picker v-model="timeIpt[0]" size="mini" style="width:150px"
                        value-format="yyyy-MM-dd HH:mm:ss" @change="dateChange" type="datetime"
                        placeholder="开始日期"/>
        <span style="display:inline-block;width:15px;text-align:center;font-size:18px">-</span>
        <el-date-picker v-model="timeIpt[1]" size="mini" style="width:150px"
                        value-format="yyyy-MM-dd HH:mm:ss" @change="dateChange" type="datetime"
                        placeholder="结束日期"/>
      </div>
      <div class="navContainer">
        <p>状态：</p>
        <el-select v-model="stateIpt" filterable size="mini" style="width:150px"
                   placeholder="请选择状态">
          <el-option v-for="item in stateOption" :key="item.label" :label="item.label"
                     :value="item.value"/>
        </el-select>
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
      </div>
    </div>
    <div class="content">
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          stripe
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
          :expand-row-keys="expands"
          :row-key="bindRowKeys"
        >
          <el-table-column label="序号" align="center" width="50px" type="index"/>
          <el-table-column prop="settNo" label="对账单编号" align="center"/>
          <el-table-column prop="title" label="标题" align="center"/>
          <el-table-column label="委托商" align="center">
            <div slot-scope="scope" style="display:flex;align-items:center;justify-content:center">
              {{ scope.row.companyNameNew }}
              <!-- 判断委托商是否 与原委托商相同  不同则展示         -->
              <el-tooltip v-if="scope.row.companyNameNew !==scope.row.companyNameOld"
                          :content="`原结算单位：${scope.row.companyNameOld}`" placement="bottom"
                          effect="light">
                <img v-if="scope.row.companyNameOld" alt=""
                     :src="require('@/assets/images/warnning.png')"/>
              </el-tooltip>
            </div>
          </el-table-column>
          <el-table-column prop="createTime" label="对账单生成时间" min-width="120" align="center"/>
          <el-table-column prop="taxPrice" label="合计含税费用" align="center"/>
          <el-table-column prop="noTaxPrice" label="合计不含税费用" min-width="110" align="center"/>
          <el-table-column prop="status" label="状态" align="center">
            <div slot-scope="scope">{{ getState(scope.row.status) }}</div>
          </el-table-column>
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
              <el-button size="mini" class="searchBtn" type="primary"
                         @click="detailClick(scope.row.id)">详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{ total }}条</span>
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="sizes,prev, pager, next,jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          @prev-click="contractCurrentChange"
          @next-click="contractCurrentChange"
        />
      </div>
    </div>
    <el-dialog title="详情" :visible.sync="detailDialogVisible" :width='detailDialogWidth'
               @close="detailClose" center top="10vh">
      <div class="detail">
        <el-tabs v-model="activeName">
          <el-tab-pane label="基础信息" name="first">
            <div class="baseInfo">
              <div class="baseInfoContent">
                <div class="baseInfoContentItem">
                  <span class="span1">对账单编号：</span>
                  <span>{{ detailData.settNo }}</span>
                </div>
                <div class="baseInfoContentItem">
                  <span class="span1">标题：</span>
                  <span>{{ detailData.title }}</span>
                </div>
                <div class="baseInfoContentItem">
                  <span class="span1">委托商：</span>
                  <span>{{ detailData.companyNameNew }}</span>
                </div>
                <div class="baseInfoContentItem specialItem">
                  <div class="specialOne">
                    <span class="span1">合计含税费用：</span>
                    <span>{{ detailData.taxPrice }}</span>
                  </div>
                  <div>
                    <span class="span1">合计不含税费用：</span>
                    <span>{{ detailData.noTaxPrice }}</span>
                  </div>
                </div>
                <div class="baseInfoContentItem specialItem">
                  <div class="specialOne">
                    <span class="span1">实际含税费用：</span>
                    <span>{{ detailData.taxPrice }}</span>
                    <el-tooltip placement="bottom" effect="light">
                      <div slot="content">
                        <span style="color: #999;">基础托运费用{{ detailData.price }}元</span><br/>
                        <span style="color: #999;">基础其它费用{{ detailData.price }}元</span><br/>
                        <span style="color: #FF3A30">抵扣超出合同价对账单{{ detailData.price }}元</span><br/>
                        <span style="color: #FF3A30">暂缓开票{{ detailData.price }}元</span><br/>
                      </div>
                      <i class="el-icon-warning"
                         style="color: red;font-size: 18px;margin-right: 5px;"/>
                    </el-tooltip>
                  </div>
                  <div>
                    <span class="span1">实际不含税费用：</span>
                    <span>{{ detailData.noTaxPrice }}</span>
                  </div>
                </div>
                <div class="baseInfoContentItem">
                  <span class="span1">生成对账单时间：</span>
                  <span>{{ detailData.createTime }}</span>
                </div>
              </div>
            </div>
            <div class="operation">
              <div class="operationTitle">
                <div class="line"/>
                <span>抵扣对账单</span>
              </div>
              <div class="operationTable">
                <el-table :data="detailData.table1" border>
                  <el-table-column label="序号" align="center" type="index"/>
                  <el-table-column prop="operateType" label="对账单编号" align="center"/>
                  <el-table-column prop="operationName" label="抵扣费用" align="center"/>
                </el-table>
              </div>
            </div>
            <div class="baseInfo">
              <div class="baseInfoTitle">
                <div class="line"/>
                <span>审核信息</span>
              </div>
              <div style="width:70%">
                <steps :step-data="stepData" :step-state="stepState"/>
              </div>
            </div>
            <div class="operation">
              <div class="operationTitle">
                <div class="line"/>
                <span>操作记录</span>
              </div>
              <div class="operationTable">
                <el-table :data="detailData.operateRecordList" border>
                  <el-table-column label="操作时间" align="center" width="160px">
                    <div slot-scope="scope">{{ getTime(scope.row.createTime) }}</div>
                  </el-table-column>
                  <el-table-column prop="operateType" label="操作类型" align="center"/>
                  <el-table-column prop="operationName" label="操作人" align="center"/>
                  <el-table-column prop="remark" label="备注" align="center"/>
                </el-table>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="作业费用" name="second">
            <div class="baseInfo">
              <div class="baseInfoContent" style="padding: 0">
                <div class="baseInfoContentItem specialItem">
                  <div class="specialOne">
                    <span class="span1">合计含税结算金额：</span>
                    <span>{{ sumCost(detailData.consignorPortInfos, 'taxPrice') }}</span>
                  </div>
                  <div>
                    <span class="span1">合计不含税结算金额：</span>
                    <span>{{ sumCost(detailData.consignorPortInfos, 'price') }}</span>
                  </div>
                </div>
              </div>
              <div class="operationTable" style="margin-top:0">
                <div class="operationTableNav">
                  <span>导出数据</span>
                </div>
                <el-table
                  :data="detailData.consignorPortInfos"
                  border
                  script
                >
                  <el-table-column prop="workNumber" label="作业编号" align="center"/>
                  <el-table-column prop="portName" label="作业港口" align="center"/>
                  <el-table-column prop="workType" label="作业类型" align="center">
                    <template slot-scope="scope">{{ scope.row.workType |workTypeFormat }}</template>
                  </el-table-column>
                  <el-table-column prop="workDate" label="作业时间" align="center">
                    <template slot-scope="scope">{{ scope.row.workDate |formatTime }}</template>
                  </el-table-column>
                  <el-table-column prop="batchNumber" label="批次号" align="center"/>
                  <el-table-column prop="chassisNumber" label="底盘号" align="center"/>
                  <el-table-column prop="brandName" label="品牌" align="center"/>
                  <el-table-column prop="modelName" label="型号" align="center"/>
                  <el-table-column prop="taxRate" label="税率(%)" align="center"/>
                  <el-table-column prop="taxPrice" label="含税单价" align="center"/>
                  <el-table-column prop="price" label="不含税单价" align="center"/>
                </el-table>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="其它费用" name="third">
            <div class="baseInfo">
              <div class="baseInfoContent" style="padding: 0">
                <div class="baseInfoContentItem specialItem">
                  <div class="specialOne">
                    <span class="span1">合计含税结算金额：</span>
                    <span>{{ sumCost(detailData.costInfos, 'costAmount') }}</span>
                  </div>
                  <div>
                    <span class="span1">合计不含税结算金额：</span>
                    <span>{{ sumCost(detailData.costInfos, 'excludingTaxAmount') }}</span>
                  </div>
                </div>
              </div>
              <div class="operationTable" style="margin-top:0">
                <el-table
                  :data="detailData.costInfos"
                  border
                  script
                >
                  <el-table-column label="序号" align="center" type="index"/>
                  <el-table-column prop="costNum" label="费用编号" align="center"/>
                  <el-table-column prop="costTypeName" label="费用类型" align="center"/>
                  <el-table-column prop="costInstruction" label="费用说明" align="center"/>
                  <el-table-column prop="costTime" label="费用时间" align="center">
                    <template slot-scope="scope">{{ scope.row.costTime |formatTime }}</template>
                  </el-table-column>
                  <el-table-column prop="taxRate" label="税率(%)" align="center"/>
                  <el-table-column prop="costAmount" label="含税价" align="center"/>
                  <el-table-column prop="excludingTaxAmount" label="不含税价" align="center"/>
                  <el-table-column prop="remark" label="说明" align="center"/>
                </el-table>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="开票信息" name="fourth">
            <div class="baseInfo">
              <div class="baseInfoContent" style="padding: 0">
                <div class="baseInfoContentItem">
                  <span class="span1">是否抵扣开票：</span>
                  <span>{{ detailData.time2 }}</span>
                </div>
                <div class="baseInfoContentItem">
                  <span class="span1">抵扣开票费用编号：</span>
                  <span>{{ detailData.time2 }}</span>
                </div>
                <div class="baseInfoContentItem specialItem">
                  <div class="specialOne">
                    <span class="span1">原开票金额：</span>
                    <span>{{ detailData.customerNatureName }}</span>
                  </div>
                  <div>
                    <span class="span1">抵扣金额：</span>
                    <span>{{ detailData.customerScaleName }}</span>
                  </div>
                </div>
              </div>
              <div class="operationTable" style="margin-top:0">
                <el-table
                  :data="detailTable2"
                  border
                  script
                >
                  <el-table-column label="序号" align="center" type="index"/>
                  <el-table-column prop="type" label="发票号码" align="center"/>
                  <el-table-column prop="remark2" label="发票金额" align="center"/>
                  <el-table-column prop="batch" label="发票日期" align="center"/>
                  <el-table-column prop="rate" label="发票类型" align="center"/>
                  <el-table-column prop="price" label="发票税率" align="center"/>
                  <el-table-column prop="price2" label="核销期限" align="center"/>
                  <el-table-column prop="remark" label="创建日期" align="center"/>
                </el-table>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
    <el-dialog title="选择适配车型" :visible.sync="carVisible" width='600px' @close="carClose" center
               :close-on-click-modal="false" top="20vh">
      <div class="carContainer">
        <div class="carContainerTitle">
          <span>已选择车型：</span>
          <div class="carContainerTitleContent">
            <div class="carContainerTitleContentItem" v-for="item in selectCar"
                 @click="selectRemove(item)">
              {{ item.name }}<i class="el-icon-close"/>
            </div>
          </div>
        </div>
        <div class="carContainerTitle">
          <span>选择品牌：</span>
          <div class="carContainerTitleContent">
            <div class="carContainerTitleContentItem" v-for="item in selectBrand">
              <p @click="brandClick(item.id)">{{ item.name }}&nbsp;</p><i class="el-icon-plus"
                                                                          @click="brandAdd(item)"/>
            </div>
          </div>
        </div>
        <div class="carContainerTitle">
          <span>选择型号：</span>
          <div class="carContainerTitleContent">
            <div class="carContainerTitleContentItem" v-for="item in selectModel"
                 @click="modelAdd(item)">
              <p>{{ item.name }}</p><i class="el-icon-plus"/>
            </div>
          </div>
        </div>
        <div class="btnContainer">
          <el-button class="searchBtn" size="mini" @click="carAddClick">确定</el-button>
          <el-button class="resetBtn" size="mini" @click="carClose">关闭</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import steps from "@/components/steps";
import {formatDateTime, formatTime} from "@/config/mUtils";
import divBorder from "@/components/divBorder";
import {
  accountList,
  accountDetail,
} from "@/service/getData"
import modifyAmountPort from "@/views/settle/client/modifyAmountPort";
import otherAdd from "@/views/settle/supplier/components/otherAdd";

export default {
  components: {
    steps,
    divBorder,
    modifyAmountPort,
    otherAdd,
  },
  data() {
    return {
      activeName: 'first',
      entrustIpt: '',
      titleIpt: '',
      numIpt: '',
      stateIpt: '',
      timeIpt: ['', ''],
      stateOption: [
        {value: '', label: '全部',},
        {value: 0, label: '待生效'},
        {value: 1, label: '生效中'},
        {value: 2, label: '已失效'},
      ],
      page: 1,
      size: 10,
      total: 0,
      tableLoad: false,
      TableDatas: [
        // {id:111,show:false,entrust:'委托商1',tip:'重庆市xxxx',status:1,tableShow:false,child:[
        //     {id:222,state:1},
        //     {id:333,state:0},
        //   ]},
        // {id:444,show:false,entrust:'委托商1',status:0,tableShow:false,child:[]},
        // {id:555,show:true,entrust:'委托商1',status:2,tableShow:false,child:[]},
        // {id:666,show:true,entrust:'委托商1',status:3,tableShow:false,child:[]},
      ],
      detailDialogVisible: false,
      detailDialogWidth: '700px',
      detailTable: [],
      detailTable2: [],
      detailTable3: [],
      detailData: {
        table1: [],
      },
      operationData: [],
      nameOption: [],
      payOption: [],
      addressOption: [],
      carVisible: false,
      selectedCar: [],
      selectCar: [],
      brands: [],
      models: [],
      brands2: [],
      models2: [],
      selectBrand: [],
      selectModel: [],
      allCar: [],
      allModel: [],
      expands: [],
      stepData: [
        {title: '张三发起', time: '2021-9-30 14:09:23', state: '', remark: ''},
        {title: '财务部 张三通过', time: '2021-9-30 14:09:23', state: 'success', remark: '原因xxxxxx'},
        {title: '技术部 李四拒绝', time: '2021-9-30 14:09:23', state: 'failure', remark: '原因xxxxxx'},
        {title: '张三重新发起', time: '2021-9-30 14:09:23', state: '', remark: ''},
      ],
    };
  },
  watch: {
    activeName(val) {
      if (val === 'first') this.detailDialogWidth = '700px';
      if (val === 'second') this.detailDialogWidth = '1000px';
      if (val === 'third') this.detailDialogWidth = '1000px';
      if (val === 'fourth') this.detailDialogWidth = '800px';
    },
  },
  filters: {
    workTypeFormat(value) {
      switch (value) {
        case 1:
          return '装船';
        case 2:
          return '卸船';
        case 3:
          return '过驳';
      }
    },
    formatTime(val) {
      return formatTime(val, "yyyy-mm-dd hh:ii:ss")
    },
  },
  computed: {
    stepState() {
      return function (state) {
        switch (state) {
          case '':
            return 'wait'
          case 'success':
            return 'success'
          case 'failure':
            return 'error'
        }
      };
    },
    getState() {
      return function (state) {
        switch (state) {
          case 0:
            return '待生效'
          case 1:
            return '生效中'
          case 2:
            return '已失效'
        }
      };
    },
    getTime() {
      return function (time) {
        return formatDateTime(time, 'yyyy年mm月dd日 hh:ii:ss')
      };
    },
    /**
     *计算合计
     * @param tableData 表格数据
     * @param field 字段名
     * @returns {function(*, *): number}
     */
    sumCost(tableData, field) {

      return function (tableData, field) {
        let sum = 0
        tableData ? tableData.forEach((item) => {
          sum += parseFloat(item[field])
        }) : 0
        return sum;
      }

    },
  },
  mounted() {
    this._accountList()
  },
  methods: {
    async _accountList() {
      let obj = {
        type: 2,//委托商港口费用
        settNo: this.numIpt,
        title: this.titleIpt,
        companyName: this.entrustIpt,
        createTime: this.timeIpt[0] ? this.timeIpt[0] : '',
        createTimeEnd: this.timeIpt[1] ? this.timeIpt[1] : '',
        status: this.stateIpt,
        page: this.page,
        rows: this.size,
      }
      this.tableLoad = true
      let res = await accountList(obj)
      this.tableLoad = false
      if (res.status !== 0) return this.$message.error(res.message)
      this.total = res.data.total
      this.TableDatas = res.data.records
    },
    compareDate(d1, d2) {
      return ((new Date(d1.replace(/-/g, "\/"))) > (new Date(d2.replace(/-/g, "\/"))));
    },
    // 结束时间
    dateChange(val) {
      if (this.timeIpt[1] && this.timeIpt[0] && this.compareDate(this.timeIpt[0], this.timeIpt[1])) {
        if (val == this.timeIpt[1]) this.timeIpt[1] = '';
        if (val == this.timeIpt[0]) this.timeIpt[0] = '';
        this.$forceUpdate();
        return this.$message.warning("结束日期必须大于开始日期！");
      }
    },
    async _accountDetail(id) {
      let res = await accountDetail(id)
      if (res.status !== 0) return this.$message.error(res.message)
      this.detailData = res.data

    },
    //主页面条数
    contractSizeChange(sizes) {
      this.size = sizes;
      this._accountList()
    },
    //主页面页数
    contractCurrentChange(page) {
      this.page = page;
      this._accountList()
    },
    detailClose() {
      this.detailDialogVisible = false;
      this.activeName = 'first'
    },
    bjDate(date, date1) {
      var date = new Date(date);
      var date1 = new Date(date1);
      // 减小于0 date<date1
      return date.getTime() - date1.getTime() < 0;
    },
    nameChange() {
    },
    carClick() {
      this.carVisible = true;
      this.selectCar = [...this.selectedCar];
      this.brands = [...this.brands2];
      this.models = [...this.models2];
    },
    selectRemove(item) {
      this.selectCar.splice(this.selectCar.indexOf(item), 1)
      if (this.brands.indexOf(item) !== -1) this.brands.splice(this.brands.indexOf(item), 1)
      else this.models.splice(this.models.indexOf(item), 1)
    },
    brandAdd(item) {
      if (this.selectCar.indexOf(item) !== -1) return this.$message.warning('已选择该品牌！');
      let arr = [];
      for (let i = 0; i < this.allCar.length; i++) {
        if (this.allCar[i].id === item.id) {
          arr = this.allCar[i].carModel;
          break;
        }
      }
      for (let i = 0; i < arr.length; i++) {
        for (let j = 0; j < this.selectCar.length; j++) {
          if (arr[i].id === this.selectCar[j].id) {
            this.selectCar.splice(j, 1);
            j--;
          }
        }
      }
      this.selectCar.push(item)
      this.brands.push(item)
    },
    modelAdd(item) {
      for (let i = 0; i < this.selectCar.length; i++) {
        if (this.selectCar[i].id === item.brandId) return this.$message.warning('上方已选择该品牌的全部车型！');
        else if (this.selectCar[i].id === item.id) return this.$message.warning('已选择该车型！');
      }
      this.selectCar.push(item)
      this.models.push(item)
    },
    carAddClick() {
      this.carVisible = false;
      this.selectedCar = [...this.selectCar];
      this.brands2 = [...this.brands];
      this.models2 = [...this.models];
    },
    carClose() {
      this.carVisible = false;
    },
    brandClick(id) {
      for (let i = 0; i < this.allCar.length; i++) {
        if (this.allCar[i].id === id) {
          this.selectModel = this.allCar[i].carModel.map(item => {
            return {
              id: item.id,
              name: item.brand_name,
              brandId: item.brand_id,
            }
          });
          break;
        }
      }
    },
    hiddenClick(index, row) {
      this.TableDatas[index].tableShow = !this.TableDatas[index].tableShow;
      Array.prototype.remove = function (val) {
        let index = this.indexOf(val);
        if (index > -1) {
          this.splice(index, 1);
        }
      };
      if (this.expands.indexOf(row.id) < 0) {
        this.expands.push(row.id);
      } else {
        this.expands.remove(row.id);
      }
    },
    detailClick(id) {
      this.detailDialogVisible = true;
      this._accountDetail(id)
      this.activeName = 'first'
    },
    //查询
    searchBtn() {
      this.page = 1;
      this._accountList()
    },
    resetBtn() {
      this.entrustIpt = '';
      this.titleIpt = '';
      this.numIpt = '';
      this.stateIpt = '';
      this.timeIpt = ['', ''];
    },

  },
};
</script>


<style lang="scss" scoped>
.mainContainer {
  width: 100%;
  padding: 20px 15px 0 25px;

  .line {
    width: 12px;
    height: 32px;
    background-color: rgba(51, 84, 131, 100);
    margin-right: 10px;
  }

  .line + span {
    font-size: 16px;
    color: rgba(51, 84, 131, 100);
    font-weight: 600;
  }

  .nav {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    &Container {
      width: 200px;
      display: flex;
      align-items: center;
      margin-right: 5px;
      margin-bottom: 5px;

      p {
        font-size: 14px;
        color: rgba(16, 16, 16, 100);
      }
    }

    &Btn {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }

    ::v-deep {
      label.el-form-item__label {
        font-weight: 500;
        color: #101010;
      }
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;

    .tableContainer {
      margin-top: 30px;
      margin-bottom: 25px;
      width: 100%;

      ::v-deep {
        .el-table__expand-icon:after {
          content: '';
        }

        .el-table__expand-icon > i {
          display: none;
        }

        .el-table__expand-column {
          border-right: none;
        }

        body .el-table th.gutter {
          display: table-cell !important;
        }

        .el-badge__content {
          top: 4px !important;
          right: 1px !important;
        }

        .el-badge__content {
          background-color: #F56C6C !important;
        }

        .el-table .cell {
          padding: 0;
        }

        .el-table th {
          padding: 0;
        }

        .el-table td {
          padding: 0;
        }
      }
    }

    .paginationContainer {
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      span {
        font-size: 13px;
      }
    }
  }

  .carContainer {
    width: 100%;
    padding: 15px 40px 10px 20px;
    max-height: 75vh;
    overflow: auto;

    &Title {
      display: flex;
      flex-direction: column;

      span {
        color: #101010;
        font-weight: 700;
        margin-bottom: 5px;
      }

      &Content {
        width: 100%;
        padding-left: 15px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin-bottom: 10px;

        &Item {
          height: 25px;
          padding: 0 5px;
          background-color: #a4adb3;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-right: 10px;
          margin-bottom: 5px;

          i {
            color: #000;
            font-size: 17px;
            cursor: pointer;
          }

          p {
            cursor: pointer;
          }
        }
      }
    }

    .btnContainer {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 30px 0 10px 0;

      button {
        margin: 0 15px;
      }
    }
  }

  .detail {
    width: 100%;
    padding: 10px 0 20px 20px;
    max-height: 80vh;
    overflow: auto;

    ::v-deep {
      .el-table td, .el-table th {
        padding: 0;
      }

      .cell {
        font-size: 10px;
        padding: 0;
      }
    }

    .baseInfo {
      display: flex;
      flex-direction: column;

      &Title {
        display: flex;
        align-items: flex-end;

        p {
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }

      &Content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 20px 23px 0 23px;

        &Item {
          margin-bottom: 20px;

          .imgContainer {
            display: flex;
            align-items: center;
          }

          .span1 {
            font-weight: 700;
          }

          span {
            font-size: 14px;
          }

          .specialOne {
            width: 50%;
          }
        }

        .specialItem {
          display: flex;
        }
      }
    }

    .operation {
      display: flex;
      flex-direction: column;

      ::v-deep {
        .el-table .ui-warning-row {
          background-color: #fef0f0 !important;
        }

        .el-table--enable-row-hover .el-table__body tr.ui-warning-row:hover > td {
          background-color: #fef0f0 !important;
        }

        .el-table .ui-warning-row .cell {
          color: red;
        }
      }

      &Title {
        display: flex;
        align-items: flex-end;

        p {
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }

      &Table {
        width: 100%;
        margin-top: 10px;
        padding: 0 20px;

        &Nav {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-end;

          span {
            color: rgba(51, 136, 255, 1);
            text-decoration: underline;
            margin-right: 10px;

            &:hover {
              cursor: pointer;
            }
          }
        }
      }
    }
  }

  .reasonContainer {
    width: 100%;
    padding: 20px 30px;

    ::v-deep {
      .el-textarea__inner {
        min-height: 100px !important;
      }
    }

    .reasonBtn {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }

  .addCost {
    display: flex;
    flex-direction: column;
    padding: 10px 40px 10px 10px;
    max-height: 75vh;
    overflow: auto;

    &Nav {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }

    &Table {
      margin-top: 30px;
      margin-bottom: 25px;
      width: 100%;

      ::v-deep {
        .el-table__expand-icon:after {
          content: '';
        }

        .el-table__expand-icon > i {
          display: none;
        }

        .el-table__expand-column {
          border-right: none;
        }

        body .el-table th.gutter {
          display: table-cell !important;
        }

        .el-table__header .el-table-column--selection .cell .el-checkbox:after {
          color: rgb(127, 127, 127);
          content: "全选";
          font-size: 12px;
          font-weight: 700;
          //margin-left: 2px;
        }

        .el-table__header .el-table-column--selection .cell .el-checkbox {
          margin-left: 8px;
        }

        .el-checkbox {
          margin-left: 16px;
        }

        .el-table .cell {
          padding: 0;
        }

        .el-table th {
          padding: 0;
        }

        .el-table td {
          padding: 0;
        }
      }
    }

    .paginationContainer {
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      span {
        font-size: 13px;
      }
    }
  }

  .depart {
    width: 100%;
    padding: 10px 40px 10px 10px;
    max-height: 75vh;
    overflow: auto;

    &Table {
      margin-bottom: 25px;
      width: 100%;

      .tableAddBtnContainer {
        border: 1px solid #EBEEF5;;
        border-top-style: none;
        width: 100%;
        height: 35px;
        display: flex;
        align-items: center;
        padding-left: 15px;

        .AddContainer {
          display: flex;
          align-items: center;

          &:hover {
            cursor: pointer;
          }
        }

        img {
          object-fit: cover;
          margin-right: 5px;
        }

        p {
          font-size: 13px;
          color: #F59A23;
          font-family: 'Arial Normal', 'Arial', sans-serif;
        }
      }

      ::v-deep {
        .el-table .cell {
          padding: 0;
        }

        .el-table th {
          padding: 0;
        }

        .el-table td {
          padding: 0;
        }
      }
    }

    .specialItem {
      ::v-deep {
        .el-form-item__content {
          margin-left: 0 !important;
        }
      }
    }

    ::v-deep {
      .el-form-item__label {
        font-weight: 700;
      }

      .el-form-item {
        margin-bottom: 13px;
      }

      .el-form-item__label {
        padding: 0;
      }

      .el-form-item__content {
        position: relative;
      }
    }

    .btnContainer {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 30px 0 10px 0;

      button {
        margin: 0 15px;
      }
    }
  }

  ::v-deep {
    .el-table th > .cell {
      font-weight: 700 !important;
    }
  }
}

::v-deep {
  .el-dialog__header {
    padding: 9px 20px 9px;
    background: #335483;
  }

  .el-dialog__title {
    line-height: 24px;
    font-size: 14px;
    color: #FFFFFF;
  }

  .el-dialog__headerbtn {
    top: 9px;
  }

  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 25px;
  }

  .el-dialog__body {
    padding: 0;
  }
}
</style>
